import { CoreAppConfig } from '@scib-microfrontends/angular-common';
import { commonEnvironment } from './common';

export const environment: CoreAppConfig = {
	...commonEnvironment,
	production: true,
	uiKitSource: 'local',
	configUrl: 'dyndis-angular-frontend/config'
};
